import React, { useContext } from "react";

import { AuditTrailViewContext } from "../AuditTrailViewContext";

const SignatureBox = ({ fullwidth, signature }) => {
  const { data } = useContext(AuditTrailViewContext);

  // Convert buffer array to string if signature prop is provided, otherwise use data.signature.data
  let signatureSrc = "";
  const signatureData = signature || data?.signature?.data;
  if (signatureData && Array.isArray(signatureData)) {
    signatureSrc = String.fromCharCode(...signatureData);
  } else if (typeof signatureData === "string") {
    signatureSrc = signatureData;
  } else if (data?.version_content?.signature) {
    signatureSrc = data.version_content.signature;
  }

  return (
    <div
      style={{
        height: "110px",
        width: fullwidth !== undefined && fullwidth === false ? "40%" : "100%",
        border: "1px solid #CED4DA",
      }}
    >
      <img src={signatureSrc} alt="" />
    </div>
  );
};

export default SignatureBox;
